/**
 * @generated SignedSource<<f2ec68d0f9a626d96816df3f6e8a9286>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "model"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activeServices",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "ServiceCard_setCurrentCompanyServiceMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SetCurrentCompanyServicePayload",
                    "kind": "LinkedField",
                    "name": "setCurrentCompanyService",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfCompany",
                            "kind": "LinkedField",
                            "name": "companyEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Company",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "ServiceCard_setCurrentCompanyServiceMutation",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "SetCurrentCompanyServicePayload",
                    "kind": "LinkedField",
                    "name": "setCurrentCompanyService",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "EdgeOfCompany",
                            "kind": "LinkedField",
                            "name": "companyEdge",
                            "plural": false,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Company",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "c632eb11d589a6e27f2947e19b4d78c9",
            "id": null,
            "metadata": {},
            "name": "ServiceCard_setCurrentCompanyServiceMutation",
            "operationKind": "mutation",
            "text": "mutation ServiceCard_setCurrentCompanyServiceMutation(\n  $model: SetCurrentCompanyServiceInput!\n) {\n  setCurrentCompanyService(model: $model) {\n    companyEdge {\n      node {\n        activeServices\n        id\n      }\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "6a8cd1c09b2bd3c7ee8992198fb510d9";
export default node;
